import { DomainSerializer } from '../../../common/domain.serializer';
import { LayoutCss } from './layout-css';

export class LayoutCssSerializer extends DomainSerializer<LayoutCss> {
}
